import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { WHY_ANCHOR, BRAND } from "@/lib/siteData";

export const WhyAnchor = () => {
  return (
    <section className="relative bg-background py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="mb-4 inline-block rounded-full bg-accent px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-foreground">
            Why Anchor Web Systems
          </span>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Built on Stability. Powered by Smart Technology.
          </h2>
        </Reveal>

        <StaggerGroup className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {WHY_ANCHOR.map((c) => {
            const Icon = Icons[c.icon] || Icons.Circle;
            return (
              <StaggerItem key={c.title}>
                <div className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-card p-8 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-elegant">
                  <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-accent/60 blur-2xl transition-opacity duration-300 group-hover:opacity-100" />
                  <div className="relative grid h-16 w-16 place-items-center rounded-2xl bg-gradient-navy shadow-card">
                    <Icon className="h-7 w-7 text-navy-foreground" />
                  </div>
                  <h3 className="relative mt-6 font-display text-2xl font-bold text-navy">{c.title}</h3>
                  <p className="relative mt-2 text-sm leading-relaxed text-muted-foreground">{c.desc}</p>
                  <ul className="relative mt-6 space-y-2.5">
                    {c.points.map((p) => (
                      <li key={p} className="flex items-center gap-2.5 text-sm font-medium text-navy">
                        <span className="grid h-5 w-5 place-items-center rounded-full bg-accent text-primary">
                          <Check className="h-3 w-3" />
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>

        {/* Tagline banner */}
        <Reveal dir="up" delay={0.1} className="mt-10">
          <div className="relative overflow-hidden rounded-3xl bg-gradient-navy px-8 py-12 text-center shadow-elegant">
            <div className="absolute inset-0 grid-pattern opacity-30" />
            <div className="absolute left-1/2 top-0 h-40 w-40 -translate-x-1/2 rounded-full bg-techblue/25 blur-3xl" />
            <p className="relative text-[11px] font-semibold uppercase tracking-[0.3em] text-techblue-glow">
              {BRAND.name}
            </p>
            <p className="relative mt-3 font-display text-3xl font-bold text-navy-foreground sm:text-4xl lg:text-5xl">
              Built to Connect. <span className="text-gradient-silver">Designed to Perform.</span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
